import { useMemo, useEffect, useRef } from "react";

import CollectionFilter from "./CollectionFilter";

const StoreCollections = ({ collections, setFilter, selectedCollection }) => {
  const collectionRefs = useRef({});

  const storeCollections = useMemo(() => {
    return collections.map((collection) => (
      <div
        key={collection._id || collection}
        ref={(el) => {
          const id = typeof collection === "string" ? collection : collection._id || collection.id;
          collectionRefs.current[id] = el;
        }}
      >
        <CollectionFilter
          collection={collection}
          selectedCollection={selectedCollection}
          setFilter={setFilter}
        />
      </div>
    ));
  }, [collections, selectedCollection, setFilter]);

  useEffect(() => {
    if (selectedCollection && selectedCollection._id !== "all") {
      const targetRef = collectionRefs.current[selectedCollection._id || selectedCollection.id];

      if (targetRef) {
        setTimeout(() => {
          targetRef.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }, 100);
      }
    }
  }, [selectedCollection]);

  return collections.length ? storeCollections : null;
};

export default StoreCollections;
